import { useContext, useMemo } from 'react';

import DashboardGadgetsContext from 'contexts/DashboardGadgetsContext';
import GoalsContext from 'contexts/GoalsContext';
import MetricListsContext from 'contexts/MetricListsContext';
import ReportGadgetsContext from 'contexts/ReportGadgetsContext';
import ScorecardsContext from 'contexts/ScorecardsContext';
import buildContentMetricIds, {
  ContentInput,
} from 'hooks/buildContentMetricIds';
import useGetMetricIdsFromVis from 'hooks/useGetMetricIdsFromVis';

export type { ContentInput };

// Taken whole rather than destructured: ContentInput is a discriminated union,
// and pulling `content`/`contentType` apart here would lose the tag on the way
// back into buildContentMetricIds.
const useContentMetricIds = (input: ContentInput): string[] => {
  const { dashboardGadgetsLookup } = useContext(DashboardGadgetsContext);
  const { scorecardsLookup } = useContext(ScorecardsContext);
  const { metricListsLookup } = useContext(MetricListsContext);
  const { reportGadgetsLookup } = useContext(ReportGadgetsContext);
  const { goals } = useContext(GoalsContext);
  const getMetricIds = useGetMetricIdsFromVis();

  return useMemo(
    () =>
      buildContentMetricIds({
        input,
        lookups: {
          dashboardGadgetsLookup,
          scorecardsLookup,
          metricListsLookup,
          reportGadgetsLookup,
          goals,
          getMetricIds,
        },
      }),
    [
      input,
      dashboardGadgetsLookup,
      getMetricIds,
      goals,
      metricListsLookup,
      reportGadgetsLookup,
      scorecardsLookup,
    ],
  );
};

export default useContentMetricIds;
